import React from 'react';
import {
  Box,
  TextField,
  InputAdornment,
  MenuItem,
  Stack,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { humanize } from '../constants';

/**
 * Search input plus an arbitrary list of dropdown filters.
 * `filters`: [{ label, value, onChange, options: [{value,label}] | string[] }]
 */
export default function SearchFilterBar({
  search,
  onSearchChange,
  searchPlaceholder = 'Search...',
  filters = [],
  children,
}) {
  return (
    <Box sx={{ mb: 2.5 }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1.5}
        alignItems={{ xs: 'stretch', sm: 'center' }}
      >
        {onSearchChange && (
          <TextField
            size="small"
            value={search ?? ''}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder={searchPlaceholder}
            sx={{ flex: 1, minWidth: 220, backgroundColor: '#fff' }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        )}
        {filters.map((filter) => (
          <TextField
            key={filter.label}
            select
            size="small"
            label={filter.label}
            value={filter.value ?? ''}
            onChange={(e) => filter.onChange(e.target.value)}
            sx={{ minWidth: 170, backgroundColor: '#fff' }}
          >
            <MenuItem value="">{filter.allLabel || 'All'}</MenuItem>
            {(filter.options || []).map((opt) => {
              const value = typeof opt === 'string' ? opt : opt.value;
              const label = typeof opt === 'string' ? humanize(opt) : opt.label;
              return (
                <MenuItem key={value} value={value}>
                  {label}
                </MenuItem>
              );
            })}
          </TextField>
        ))}
        {children}
      </Stack>
    </Box>
  );
}
